import React, { useEffect } from 'react'

import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'

import { CookieConsent } from './components/Cookie'
import { Footer } from './components/Footer'
import { Header } from './components/Header/Header'
import { AboutMe } from './pages/about-me/About-me'
import { Imprint } from './pages/Imprint'
import { LandingPage } from './pages/landing/LandingPage'
import { Privacy } from './pages/Privacy'
import { AmbulantOperation } from './pages/services/components/Ambulant/AmbulantOperation'
import { Services } from './pages/services/Services'
import { Team } from './pages/Team'

function App() {
    const ScrollToHashElement = () => {
        const { hash } = useLocation()

        useEffect(() => {
            if (hash) {
                const element = document.getElementById(hash.substring(1))
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                }
            }
        }, [hash])

        return null
    }
    const { i18n } = useTranslation()

    useEffect(() => {
        const storedLang = Cookies.get('preferredLanguage')
        if (storedLang) {
            i18n.changeLanguage(storedLang)
        } else {
            const browserLang = navigator.language.split('-')[0]
            i18n.changeLanguage(browserLang)
        }
    }, [i18n])

    return (
        <>
            <CookieConsent />
            <Header />

            <BrowserRouter>
                <ScrollToHashElement />
                <Routes>
                    <Route
                        path="/"
                        element={
                            <div className="flex justify-center">
                                <LandingPage />
                            </div>
                        }
                    />
                    <Route path="/about-me" element={<AboutMe />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/imprint" element={<Imprint textColor="text-primary-blue-faded" />} />
                    <Route path="/privacy" element={<Privacy textColor="text-primary-blue-faded" />} />
                    <Route path="/ambulant-operation" element={<AmbulantOperation />} />
                    <Route path="/team" element={<Team className="max-w-container-s" />} />
                </Routes>
            </BrowserRouter>

            <Footer />
        </>
    )
}
export default App
